// A min/max band: a range `<Area>` (recharts renders a `[lo, hi]`
// datum tuple as a range natively). Painted before series so it sits
// behind them; axis ids from the orientation model.

import { Area } from 'recharts';

import type { BandSpec } from '#core/lib/expr/ops/dashboard/value.ts';
import { CHART_SHADE, chartElementColor, fillOpacity, mantineColorVar } from '#core/lib/formatters/colors.ts';

import { bandDataKey } from './band-keys.ts';
import type { ChartOrientation } from './chartOrientation.ts';

export function ChartBand({ o, band: b, index }: { o: ChartOrientation; band: BandSpec; index: number }) {
  const bandColor = chartElementColor(b.color, index);
  return (
    <Area
      activeDot={false}
      connectNulls={false}
      dataKey={bandDataKey(index)}
      dot={false}
      fill={mantineColorVar(bandColor, CHART_SHADE.ref)}
      fillOpacity={fillOpacity.band}
      isAnimationActive={false}
      legendType="none"
      name={b.label ?? 'band'}
      stroke="none"
      {...o.seriesAxisIds(b.axis ?? 'left')}
    />
  );
}
